// ConsolidationSettings.js
import React from 'react';
import { Form, Checkbox } from 'antd';

const ConsolidationSettings = () => (
  <>
    <Form.Item name="consolidateApprovals" valuePropName="checked">
      <Checkbox>Consolidate Approvals</Checkbox>
    </Form.Item>

    <Form.Item name="consolidateNotification" valuePropName="checked">
      <Checkbox>Consolidate Notification</Checkbox>
    </Form.Item>

    <Form.Item name="continuePendingApprovals" valuePropName="checked">
      <Checkbox>Continue Pending Approvals on Reject</Checkbox>
    </Form.Item>
  </>
);

export default ConsolidationSettings;
